<script setup lang="ts">
const isLoaded = ref(false)
const hasError = ref(false)

function handleLoad() {
  isLoaded.value = true
  hasError.value = false
}

function handleError() {
  hasError.value = true
  isLoaded.value = false
}
</script>

<template>
  <div class="rounded-lg overflow-hidden">
    <!-- Iframe виджет -->
    <iframe
      v-if="!hasError"
      class="rounded-lg"
      src="https://yandex.ru/sprav/widget/rating-badge/47168271231?type=rating&theme=dark"
      width="150"
      height="50"
      frameborder="0"
      referrerpolicy="no-referrer-when-downgrade"
      sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
      title="Рейтинг на Яндекс.Картах"
      @load="handleLoad"
      @error="handleError"
    />

    <!-- Fallback ссылка -->
    <a
      v-else
      href="https://yandex.ru/maps/org/47168271231/"
      target="_blank"
      rel="noopener noreferrer"
      class="w-[150px] h-[50px] bg-gray-700 hover:bg-gray-600 rounded-lg border border-gray-600 transition-colors flex items-center justify-center text-white text-sm"
    >
      <div class="text-center">
        <div class="text-xs text-gray-300">Рейтинг на</div>
        <div class="font-medium">Яндекс.Картах</div>
      </div>
    </a>
  </div>
</template>
